import Cookies from 'js-cookie';
import postProcessApiResponse from '../postProcessApiResponse';
import { showInternalErrorNotification, showUnexpectedErrorNotification } from '../notifications';
import ApiError, { ApiErrorType } from './ApiError';
import handleUnauthorizedRequest from './handleUnauthorizedRequest';

/**
 * This method is essentially the native fetch implementation with post-fetch error handling for AppStats
 */
export default async function fetchWithPostErrorProcessing(
    url,
    { signal, ...otherFetchOptions } = {},
    logErrorMsgs = false,
    returnRawResponse = false,
    returnErrMsg = false,
) {
    const csrfToken = Cookies.get('XSRF-TOKEN');

    const apiResponse = await fetch(url, {
        signal,
        ...otherFetchOptions,
        headers: {
            'X-XSRF-TOKEN': csrfToken,
            'Content-Type': 'application/json; charset=utf-8',
        },
    });

    // currently only used for exports as the status check endpoint only returns a status without json body
    if (returnRawResponse && (apiResponse.status === 400 || apiResponse.status === 200)) {
        return apiResponse;
    }

    if (returnErrMsg) {
        return apiResponse.json();
    }

    if (apiResponse.status === 401) {
        handleUnauthorizedRequest();
        return null;
    }

    if (signal && signal.aborted) {
        return null;
    }

    if (apiResponse.status === 500) {
        showInternalErrorNotification();
    } else if (apiResponse.status !== 200) {
        showUnexpectedErrorNotification();
    }

    if (apiResponse.status !== 200) {
        throw new ApiError(ApiErrorType.BAD_STATUS);
    }

    return postProcessApiResponse(await apiResponse.json(), logErrorMsgs);
}
